import { render, staticRenderFns } from "./join_user.vue?vue&type=template&id=0d78e882&scoped=true"
import script from "./join_user.vue?vue&type=script&lang=js"
export * from "./join_user.vue?vue&type=script&lang=js"
import style0 from "./join_user.vue?vue&type=style&index=0&id=0d78e882&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d78e882",
  null
  
)

export default component.exports